/* eslint-disable import/no-anonymous-default-export */
import React, { useState, useEffect } from 'react';
import withInfiniteScroll from 'global/components/withInfiniteScroll';
import { useSelector, useDispatch } from 'react-redux';
import { buildFilters } from 'global/utils/filter';
import { get, set, size } from 'global/lib/lodash';
import { List, ListItem, ListItemText, Chip } from '@mui/material';
import TaskListItem from './TaskListItemSC';
import { useScreen } from 'global/styles';
import useStyles from './TaskListSC.styles';
import useRetrieveData from 'global/hooks/useRetrieveData';
import Print from 'global/components/print';
import TaskNotify from '../TaskNotify';
import { getRealmName } from 'global/utils';
import withSearchBar from 'global/components/withSearchBar';
import { Text } from 'global/components/text';
import PerformTasksFilters from '../Filters';
import clsx from 'clsx';
import { FilterChips } from 'global/components/filterchips';
import { getTradeName } from '../../../global/components/trade-select';
import { ensureArray, stopProp } from '../../../global/utils';
import { StatusDrop } from '../TaskRealm/TaskRealm';
import { Checkbox } from '../../../global/components/checkbox';
import { useView } from '../../../global/hooks/useView';
import { Row } from '../../../global/components/row';
import { LinkButton } from '../../../global/components/Button';
import { QuickEditModal } from '../TaskRealm/TaskRealm';
import { DetailModal } from '../TaskDetail';
import { uniqBy } from 'lodash';

export const Includes = [
  'authors',
  'assignees',
  'viewers',
  'assessment',
  'realm',
  'realm.parent',
  'scorecardScore',
  'tradeTypes',
  'images',
  'comments',
];
const pageSize = 25;

const TableRows = [
  { title: <Checkbox />, width: '5%', val: item => <Checkbox checked={!!item.isSelected} onClick={e => { stopProp(e); item.onCheckClick() }} /> },
  { title: 'Location', width: '29%', val: (item) => getRealmName(item, item.label) },
  { title: 'Author', width: '25%', val: (item) => get(item, 'author'), canDisplay: ({ filter }) => get(filter, 'content') === 'users' },
  { title: 'Assignee', width: '25%', val: (item) => get(item, 'assignee'), canDisplay: ({ filter }) => get(filter, 'content') === 'users' },
  { title: 'Title', width: '25%', val: (item) => get(item, 'name'), canDisplay: ({ filter }) => get(filter, 'content') === 'title' },
  { title: 'Trade Type', width: '24%', val: (item) => get(item, 'tradeTypes', []).map(t => <Chip style={{ margin: `2px 2px` }} size="small" label={getTradeName(t)} />) },
  { title: 'Age', width: '8%', val: (item) => get(item, 'agingDate') },
  { title: 'Status', width: '14%', id: 'status' },
];

let printPromise = {};
let selectAllPromise = {};
export default (props) => {
  const include = Includes.join(',');
  const filter = useSelector((state) => get(state, 'filter.tasks.scorecard'));
  const realmId = useSelector((state) => get(state, 'auth.realm.id'));
  const [urlParams, setUrlParams] = useState({ waitFor: null, build: ['tasks'], params: { page: { size: pageSize, number: 1 }, include } });
  const { isMobile } = useScreen();
  const classes = useStyles();
  const dispatch = useDispatch();
  const [printing, _printing] = useState(false);
  const [selAllOpt, _selAllOpt] = useState(false);
  const [data, setData] = useState([]);
  const newTasks = useSelector((state) => get(state, 'view.task.new'));
  const view = useView();
  const [taskDetail, setTaskDetail] = useState({
    open: false,
    useHistory: false,
  })

  const getFilters = (extra = {}) => {
    return buildFilters(
      {
        ...filter,
        ...extra,
      },
      {
        convertName: { searchstring: 'name', realm_type: 'tier' },
        includeRealm: true,
        dontFilter: ['content'],
        overrideSort: s => {
          return s.map(k => k.includes('updated_at') ? '-updated_at' : k);
        },
        overrideFilter: (_filtObj) => {
          const filtObj = { ..._filtObj };
          if (filtObj.vendor_id === 0) {
            delete filtObj.vendor_id;
          }

          if (filtObj.status) {
            const st = typeof filtObj.status == 'string' ? filtObj.status.split(',') : filtObj.status;
            const statArray = ensureArray(st);
            statArray.map(a => set(filtObj, a, true));
            delete filtObj.status;
          }

          if (filtObj.age === 0) {
            delete filtObj.age;
          }

          return filtObj;
        },
      }
    );
  };

  const tasks = useRetrieveData({ url: '/tasks' }, urlParams);

  const [quickEdit, setQuickEdit] = useState({
    open: false,
  })

  const setFilters = (clear) => {
    if (clear) {
      setData([]);
    }
    setUrlParams({
      ...urlParams,
      useEffect: true,
      waitFor: undefined,
      params: {
        ...urlParams.params,
        ...getFilters(),
        page: { size: pageSize, number: 1 },
      },
    });
  };

  useEffect(() => {
    const datalist = uniqBy([...data, ...tasks.data], 'id'); 
    view.setTaskList(datalist);
    setData(datalist);
  }, [tasks.data]);

  useEffect(() => {
    setFilters(false);
  }, [filter, realmId]);

  useEffect(() => {
    if (printing && !tasks.loading) {
      _printing(false);
      printPromise.resolve();
    }

    if (selAllOpt && !tasks.loading) {
      _selAllOpt(false);
      selectAllPromise.resolve(tasks);
    }

    if (tasks.loading && get(urlParams, 'params.page.number') == 1) {
      setData([]);
    }
  }, [tasks.loading]);

  const lastPage = get(tasks, 'meta.page.last-page', null);
  const updatePage = (newPage) => {
    if (newPage <= lastPage) {
      setUrlParams({
        ...urlParams,
        params: {
          ...urlParams.params,
          page: { size: pageSize, number: newPage },
        },
      });
    }
  };

  const meta = get(tasks, 'meta.page', {});
  const sel = size(get(view, 'view.task.new'));

  const clearPageFilter = () => {
    const params = { ...urlParams };
    delete params.params.page;
    setUrlParams({
      ...params,
      useEffect: false,
    });
  }

  const onPrint = () => {
    return new Promise((resolve, reject) => {
      printPromise.resolve = resolve;
      printPromise.reject = reject;

      const LIMIT = 1000;
      const totalCount = meta.total;

      if (totalCount > LIMIT) {
        reject();
        return alert(`Too many tasks to print. Please limit your search results to a maximum of ${LIMIT}.`);
      }

      clearPageFilter();
      _printing(true);
    });
  };

  const hasSelected = !!size(get(view, 'view.task.new'));
  
  const selectAll = e => {
    if (hasSelected) {
      view.removeNewTasks();
    } else {
      view.addNewTasks(data.map(d => ({ ...d, fromSelected: true })))
    }
  }

  const handleSelection = (e, item, selected) => {
    stopProp(e);
    setQuickEdit(q => ({ 
      ...q, 
      open: true, 
      item: { item, task: item }, 
      selected,
      onClose: (created) => {
        setQuickEdit(s => ({ ...s, open: false }));

        const cre = get(created, '0.task');

        if (cre) {
          const newset = data.map(d => {
            if (d.id == cre.id) {
              return cre;
            }
            return d;
          })

          setData(newset);
        }
      },
    }))
  }

  const clickRow = (e, item) => {
    if (quickEdit.dropOpen) { return }
    setTaskDetail(s => ({ 
      ...s, 
      taskId: item.id, 
      open: true,
      onClose: (t) => {
        setTaskDetail(s => ({ ...s, open: false }));
        if (!!t) {
          const nd = data.map(d => d.id == t.id ? t : d);
          setData(nd);
        }
      },
    }))
  }

  const tableRows = TableRows.filter((tr) => (tr.canDisplay ? tr.canDisplay({ filter }) : true)).map((tr, i) => {
    if (i == 0) {
      set(tr, 'title', <Checkbox checked={hasSelected} onClick={selectAll} />)
    }
    if (tr.id == 'status') {
      set(tr, 'val', item => <StatusDrop item={item} onOpen={() => setQuickEdit(qe => ({ ...qe, dropOpen: true }))} onClose={() => setQuickEdit(qe => ({ ...qe, dropOpen: false }))} onSelect={(e, v) => handleSelection(e, item, v)} />)
    }
    return { ...tr }
  });

  const selectAllOnServer = () => {
    return new Promise((resolve, reject) => {
      selectAllPromise.resolve = (tk) => {
        view.addNewTasks(get(tk, 'data', []).map(t => ({ ...t, fromSelected: true })));
        resolve();
      } 
      selectAllPromise.reject = reject;

      if (!get(urlParams, 'params.page')) {
        return selectAllPromise.resolve(tasks);
      }

      clearPageFilter();
      _selAllOpt(true)
    })
  }
  
  const renderTaskNotify = () => {
    const curSelSize = sel;
    const total = get(meta, 'total', '0');
    const allIsSelected = sel == total;

    const showTotal = total > curSelSize;

    return (
      <div>
        {showTotal && <div className={classes.notifyTopHeader}>
          <Row>
            {`${allIsSelected ? 'All ' : ''}${sel} items on this page are selected. `}
            <LinkButton loading={tasks.loading} onClick={selectAllOnServer} variant="default" color="secondary">{`Select all ${total} tasks that match this filter criteria`}</LinkButton>
          </Row>
        </div>}
        <TaskNotify allIsSelected={allIsSelected} />
      </div>
    )
  }

  return (
    <>
      {!isMobile && <Print onPrint={onPrint} onFinish={() => setFilters(true)} className={classes.printBtn} />}

      <div className={clsx(classes.padLeft)}>
        {!isMobile && <Text type={'headline_medium'}>{`Task List`}</Text>}
        {isMobile ? <PerformTasksFilters {...props} /> : <FilterChips id={'tasks.age'} />}
      </div>

      <ListWithPages
        {...props}
        handlePageChange={updatePage}
        currentPage={get(urlParams, 'params.page.number', 1)}
        lastPage={lastPage}
        loading={tasks.loading}
        data={data}
        tableRows={tableRows}
        trackChecks={newTasks}
        alwaysReplaceData
        onClick={clickRow}
        header={hasSelected ? renderTaskNotify() : 
          <ListItem component={'div'} disableGutters={true} className={classes.tableHeader}>
            <ListItemText
              secondaryTypographyProps={{ component: 'div' }}
              secondary={isMobile ? <Row>{tableRows[0].title} {`Task Info`}</Row> :
                <div className={classes.tableRow}>
                  {tableRows.map((tr, i) => (
                    <div key={i} className={classes.tableRow} style={{ width: tr.width, fontWeight: 'bold' }}>
                      {tr.title}
                    </div>
                  ))}
                </div>
              }
            />
          </ListItem>
        }
      />

      <QuickEditModal {...quickEdit} />

      <DetailModal {...taskDetail} />
    </>
  );
};

const ListWithPages = withSearchBar(withInfiniteScroll(TaskListItem, List));
